import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  DurationSchemaWithMax,
  DurationUnits,
  RunMode,
} from '../base/baseSchema.js';
import { BlockValueUsPhoneNumberSchema } from '../base/blockValueUsPhoneNumberSchema.js';
import { CommunicationWindowSchema } from '../base/communicationWindow.js';
import { OUTBOUND_CALL_AND_SMS_ALLOWED_COUNTRIES } from '../base/phoneNumberCountries.js';

export const SendSmsBlockConfigSchema = z.object({
  calleePhoneNumber: BlockValueUsPhoneNumberSchema({
    isRequired: true,
    allowedCountries: OUTBOUND_CALL_AND_SMS_ALLOWED_COUNTRIES,
  }),
  callerPhoneNumberId: z.string().uuid('Must be a valid phone number configuration id.').nullish(),
  message: z.string().min(1, 'This field is required.'),
  timeout: DurationSchemaWithMax('value', { value: 60, units: DurationUnits.Minutes }),
  runMode: z.enum(RunMode).optional().default(RunMode.Live),
  communicationWindow: CommunicationWindowSchema.optional(),
});
export type SendSmsBlockConfig = z.infer<typeof SendSmsBlockConfigSchema>;

export const SendSmsBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.SendSms),
  config: SendSmsBlockConfigSchema,
});
export type SendSmsBlock = z.infer<typeof SendSmsBlockSchema>;
